import { Check } from '@/assets/icons'
import clsx from 'clsx'

export type CaseStatusCheckedLabelSize = 'compact' | 'default'

type CaseStatusCheckedLabelProps = {
  label?: string
  size?: CaseStatusCheckedLabelSize
  className?: string
}

const sizeStyles: Record<CaseStatusCheckedLabelSize, { icon: string; text: string }> = {
  compact: {
    icon: 'size-3',
    text: 'text-2xs leading-[11.2px]',
  },
  default: {
    icon: 'size-4',
    text: 'text-xs leading-4',
  },
}

export function CaseStatusCheckedLabel({ label = 'No flags detected', size = 'default', className }: CaseStatusCheckedLabelProps) {
  const styles = sizeStyles[size]

  return (
    <span className={clsx('inline-flex items-center gap-[2px] text-true-gray-600 whitespace-nowrap', className)}>
      <Check className={clsx('shrink-0', styles.icon)} aria-hidden="true" />
      <span className={styles.text}>{label}</span>
    </span>
  )
}
